import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary, secondary } = theme.palette;

  return {
    actions: {
      borderTop: `1px solid ${theme.palette.text.hint}`,
      padding: "12px",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        justifyContent: "center"
      }
    },
    actionButton: {
      width: 143,
      height: 33,
      color: "#333",
      borderRadius: 2,
      boxShadow: "none",
      border: `1px solid ${primary.dark}`,
      "&.Mui-disabled": {
        border: "none",
        backgroundColor: "#eee",
        color: primary.light
      },
      "&:last-child": {
        marginLeft: 12
      },
      "&:hover": {
        boxShadow: "none"
      }
    },
    applyButton: {
      color: theme.palette.common.white,
      backgroundColor: secondary.dark,
      border: "none",
      "&:hover": {
        backgroundColor: "#7ad8b3"
      }
    }
  };
});
